import { API } from "../../apiSlice";

export const getLoanApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    getLoan: builder.query({
      query: (id) => {
        return {
          url: `users/loan-request/${id}`,
        };
      },
    }),
  }),
});

export const { useGetLoanQuery } = getLoanApiSlice;
